module.exports = __webpack_public_path__ + "media/prk/assets/images/login/knowledge-2a8169d5c4870e494bb10a4a5d43f2c3.svg";